import { createGlobalState } from '@vueuse/core';
import { ref, computed, watch } from 'vue'
import { useCompareInit } from './useCompareInit';
import { useCompareUrlState } from './useCompareUrlState';
import { useCompareWording } from '@/composables/useCompareWording';
import _ from 'lodash';

const CLMS_TYPE = 'CLMS';
const DESC_TYPE = 'DESC';

export const DESC_ROUTE_PATH = 'desc';
export const CLMS_ROUTE_PATH = 'clms';
export const COMPARE_ROUTE_PATH = 'compare';

// 维护滚动相关的响应式变量
export const useSimilarParaScroll = createGlobalState(() => {

    const { compareResultList, isStartInit, deferred } = useCompareInit();
    const { isSourcePatent } = useCompareUrlState();
    const { isCompareWordingStart, compareWordingParaNumMap } = useCompareWording();

    const isScrollImmediately = ref<{ left:boolean; right:boolean; }>({
        left: false,
        right: false
    })

    const similarParaMap = computed(() => {
        const map = {};
        _.forEach(compareResultList.value, item => {
            map[item.paragraph_id] = item.target;
        })
        return map;
    });

    const curSimilarParaNum = ref<string>('');
    const curSimilarParaNumSerialIdx = ref(1);

    const curSimilarParaList = computed(() => {
        return similarParaMap.value[curSimilarParaNum.value];
    })

    const curSimilarParaListLeng = computed(() => {
        return curSimilarParaList.value?.length || 0;
    });


    const showSimilarParaBar = computed(() => {
        return curSimilarParaListLeng.value > 1;
    })

    // 相似段落在权利要求的命中数量
    const curSimilarParaInClmsCount = computed(() => {
        return _.filter(curSimilarParaList.value, item => {
            return item.field_type === CLMS_TYPE;
        }).length;
    })

    // 相似段落在说明书的命中数量
    const curSimilarParaInDescCount = computed(() => {
        return _.filter(curSimilarParaList.value, item => {
            return item.field_type === DESC_TYPE;
        }).length;
    })
     
    // 滚动相关数据: 当前路由及处于当前路由的位置
    // 对比栏滚动信息
    const curTargetPatentScrollInfo = computed(() => {
        let name = CLMS_ROUTE_PATH;
        let index = curSimilarParaNumSerialIdx.value;
        if (curSimilarParaNumSerialIdx.value > curSimilarParaInClmsCount.value) {
            name = DESC_ROUTE_PATH;
            index = curSimilarParaNumSerialIdx.value - curSimilarParaInClmsCount.value;
        }

        return {
            num: curSimilarParaNum.value,
            name,
            index,
        };
    })

    // 主题栏滚动信息
    const curSourcePatentScrollInfo = computed(() => {
        // 点击的时候判断这里的路由位置
        let name = '';
        if (isSourcePatent.value) {
            name = CLMS_ROUTE_PATH;
            if (compareWordingParaNumMap.value[curSimilarParaNum.value]) {
                name = compareWordingParaNumMap.value[curSimilarParaNum.value].path;
            }
        } else {
            name = COMPARE_ROUTE_PATH;
        }
        return {
            name,
            index: 1,
            num: curSimilarParaNum.value,
        };
    })

    const changeSimilarParaNumSerialIdx = (index:number) => {
        curSimilarParaNumSerialIdx.value = index;
    }

    const changeSimilarParaNum = (num:string) => {
        curSimilarParaNum.value = num;
        changeSimilarParaNumSerialIdx(1);
    }

    const changeScrollImmediately = ({ side, status }) => {
        if (side === 'both') {
            isScrollImmediately.value = {
                left: status,
                right: status,
            }
        } else {
            isScrollImmediately.value[side] = status;
        }
    }

    const getCurScrollInfo = (target) => {
        // @ts-ignore
        const params: {
            num: string;
            target: string;
            index: number;
            name: string;
        } = {
            target,
            num: curSimilarParaNum.value,
        };
        if (target === 'left') {
            params.index = 1;
            params.name = curSourcePatentScrollInfo.value.name;
        } else {
            params.index = curTargetPatentScrollInfo.value.index;
            params.name = curTargetPatentScrollInfo.value.name;
        }
        return params;
    }

    watch(isStartInit, async () => {
        if (isStartInit.value) {
            changeSimilarParaNum('');
            await deferred.value?.promise;
            if (compareResultList.value?.length && !isCompareWordingStart.value) {
                // 定位到第一个相似段
                changeSimilarParaNum('1');
                changeScrollImmediately({
                    side:'both',
                    status: true
                });
            }
        }
    })


    return {
        curSimilarParaNum,
        curSimilarParaList,
        curSimilarParaNumSerialIdx,
        curSimilarParaListLeng,
        curTargetPatentScrollInfo,
        curSourcePatentScrollInfo,
        
        showSimilarParaBar,
        isScrollImmediately,


        changeSimilarParaNum,
        changeSimilarParaNumSerialIdx,
        changeScrollImmediately,
        getCurScrollInfo,
    }

})
